import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  page: null,
  isFetching: false,
  isProcessUserState: false,
  isProcessJoinLesson: false,
  isProcessJoinModuleLesson: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchModulePage]: state => {
      return {
        ...state,
        page: initialState.page,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchModulePageSuccess]: (state, action) => {
      return {
        ...state,
        page: action.result,
        isFetching: false,
      }
    },
    [actions.fetchModulePageFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    },
    [actions.fetchCourseUserState]: state => {
      return {
        ...state,
        isProcessUserState: true,
      }
    },
    [actions.fetchCourseUserStateSuccess]: (state, action) => {
      return {
        ...state,
        progress: action.result,
        isProcessUserState: false,
      }
    },
    [actions.fetchCourseUserStateFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessUserState: false,
      }
    },
    [actions.joinLesson]: state => {
      return {
        ...state,
        isProcessJoinLesson: true,
      }
    },
    [actions.joinLessonSuccess]: state => {
      return {
        ...state,
        isProcessJoinLesson: false,
      }
    },
    [actions.joinLessonFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessJoinLesson: false,
      }
    },
    [actions.joinModuleLesson]: state => {
      return {
        ...state,
        isProcessJoinModuleLesson: true,
      }
    },
    [actions.joinModuleLessonSuccess]: state => {
      return {
        ...state,
        isProcessJoinModuleLesson: false,
      }
    },
    [actions.joinModuleLessonFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessJoinModuleLesson: false,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
